import { ColumnData } from '../../../../tables/ultraTable/types/column.types';

// 200px estimated padding and index - This is still hardcoded at 12 column minsize which is not ideal
const SIZE = (window.innerWidth - 200) / 12;
const MIN_SIZE = 100;

export const COUNTERPARTY_COLUMNS: ColumnData[] = [
  {
    id: 'name',
    title: 'Asset',
    filterVariant: 'select',
    filterFn: 'arrIncludesSome',
    size: 300,
    minSize: MIN_SIZE,
  },
  {
    id: 'asset_class',
    title: 'Asset Class',
    filterVariant: 'select',
    filterFn: 'arrIncludesSome',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'asset_type',
    title: 'Asset Type',
    filterVariant: 'select',
    filterFn: 'arrIncludesSome',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'isin',
    title: 'ISIN',
    filterVariant: 'select',
    filterFn: 'arrIncludesSome',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'currency',
    title: 'Currency',
    filterVariant: 'select',
    filterFn: 'arrIncludesSome',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'fx',
    title: 'FX Rate',
    filterFn: 'inNumberRange',
    filterVariant: 'inNumberRange',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'lc_exposure',
    title: 'Local Exposure',
    filterFn: 'inNumberRange',
    filterVariant: 'inNumberRange',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'bc_exposure',
    title: 'Base Exposure',
    filterFn: 'inNumberRange',
    filterVariant: 'inNumberRange',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'gross_exposure',
    title: 'Gross Exposure',
    filterFn: 'inNumberRange',
    filterVariant: 'inNumberRange',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'gross_exposure_pct',
    title: 'Gross Exposure %',
    filterFn: 'inNumberRange',
    filterVariant: 'inNumberRange',
    size: SIZE,
    minSize: MIN_SIZE,
  },
  {
    id: 'unrealised_pl',
    title: 'Unrealised P/L',
    filterFn: 'inNumberRange',
    filterVariant: 'inNumberRange',
    size: SIZE,
    minSize: MIN_SIZE,
  },
];
